/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PROCESSING_FEE } from "../pages/AssetDetail/graphql/get-processing-fee.query";
import { toast } from "react-hot-toast";

const MODULE_NAME = "ProcessingFeeService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ProcessingFeeService {
    private static instance: ProcessingFeeService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): ProcessingFeeService {
        if (!ProcessingFeeService.instance) {
            ProcessingFeeService.instance = new ProcessingFeeService(props);
        }
        return ProcessingFeeService.instance;
    }

    async ProcessingFee(currencyType:string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_PROCESSING_FEE,
                    variables: {
                        currencyType:currencyType
                    },
                    fetchPolicy: "network-only",
                });

                if (res) {
                    return res?.data?.getPlateformFee?.plateformFee;
                }
            }
        } catch (err) {
            log.error(MODULE_NAME, "error getting processing fee", err);
            // throw Error(`${err?.message}`)
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}